import { i18nMark } from 'lingui-react';

const messages = {
  administration: i18nMark('Administration'),
  approvals: i18nMark('Approvals'),
  assets: i18nMark('Assets'),
  cases: i18nMark('Cases'),
  collapsed: i18nMark('Collapse Sidebar'),
  expanded: i18nMark('Expand Sidebar'),
  reports: i18nMark('Reports'),
  serviceRequests: i18nMark('Service Requests'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/LeftNav/LeftNavComponent/messages.js